export { ContentSectionPhotoAlbum } from "./componen-content-section-photo-album";
